import {useParams} from 'react-router-dom';
import {articles} from "../data/articles/articles";
import {Container} from "reactstrap";


function ArticlePage() {
    const {slug} = useParams();
    const article = articles[slug];

    if (!article) {
        return <h1>404 - Makale bulunamadı</h1>;
    }

    const contentParagraphs = article.content.split('\n').filter(p => p.trim() !== '');

    return (
        <Container style={{marginTop: 40}}>
            <div className="section">
                <h1>{article.title}</h1>
                <img src={article.image} alt={article.title} style={{maxWidth: "400px"}}/>
                <div style={{marginTop: 20}}>
                    {contentParagraphs.map((paragraph, index) => (
                        <p key={index}>{paragraph}</p>
                    ))}
                </div>
            </div>
        </Container>
    );
}

export default ArticlePage;
